module.exports = __webpack_public_path__ + "static/img/union.51e86226.png";